import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    LoggerStatus,
} from 'app/enums/label.enums'
import {
    LoggerResponse,
} from '../Loggers.types'
import {
    availableLoggerStatuses,
} from '../Logger/Logger.utils'

export type LoggerCreate = {
    softwareVersion: string,
    hardwareVersion: string,
}

type LoggerFields = keyof LoggerCreate | keyof LoggerResponse

const loggerCreateFields = (
    loggerStatus: LoggerStatus,
): DTOCardFormField<LoggerFields>[] => {
    return [{
        id: 'loggers',
        title: 'Logger',
        className: 'loggers',
        fields: [
            {
                id: 'loggers-column1',
                fields: [
                    {
                        name: 'loggerNumber',
                        componentName: 'InputSingleline',
                        required: true,
                    },
                    {
                        name: 'loggerQrCode',
                        componentName: 'InputSingleline',
                        required: true,
                    },
                    {
                        name: 'loggerStatus',
                        componentName: 'EnumSelector',
                        required: true,
                        useDropdown: true,
                        value: loggerStatus || LoggerStatus.ACTIVE,
                        allowedValues: availableLoggerStatuses,
                    },
                    {
                        name: 'loggerType',
                        componentName: 'LoggerTypeSelector',
                        required: true,
                    },
                ],
            },
            {
                id: 'loggers-column2',
                fields: [
                    {
                        name: 'hardwareVersion',
                        componentName: 'InputSingleline',
                    },
                    {
                        name: 'softwareVersion',
                        componentName: 'InputSingleline',
                    },
                ],
            },
            {
                id: 'loggers-column3',
                fields: [
                    {
                        name: 'transmissionRateSecondsStatic',
                        componentName: 'IntegerInput',
                    },
                    {
                        name: 'transmissionRateSecondsMobile',
                        componentName: 'IntegerInput',
                    },
                    {
                        name: 'measurementIntervalSeconds',
                        componentName: 'IntegerInput',
                    },
                ],
            },

        ],
    }]
}

export default loggerCreateFields
